import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../../Assets/images/hlogo.png'
import { Link, NavLink, useLocation } from 'react-router-dom';
import sidebar from './Sidebar'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import getServices from '../../Services/get-service';
import putServices from '../../Services/put-service';
import cookie from 'react-cookies';
import Routess from './Routes';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Overview from '../../Components/Dashboard/Overview';
import MainDetails from '../../Components/Customers/MainDetails';
import { listenToForegroundMessages } from '../../utils/foregroundNotifications';

const drawerWidth = 240;
const REFRESH_DEDUPE_WINDOW = 2000;
let refreshTokenPromise = null;
let lastRefreshTokenCallAt = 0;

const refreshAdminToken = () => {
  const now = Date.now();

  if (refreshTokenPromise || now - lastRefreshTokenCallAt < REFRESH_DEDUPE_WINDOW) {
    return refreshTokenPromise || Promise.resolve(null);
  }

  lastRefreshTokenCallAt = now;
  refreshTokenPromise = getServices.refreshToken().finally(() => {
    refreshTokenPromise = null;
  });

  return refreshTokenPromise;
};

const routeToPageName = {
  '/dashboard': 'Dashboard',
  '/': 'Dashboard',
  '/customers': 'Users',
  '/wallet': 'Wallet',
  '/assests': 'Asset Financing',
  '/investment': 'Investments',
  '/savings': 'Savings',
  '/transaction': 'Transactions',
  '/users': 'Administrators',
  '/settings': 'Settings',
  '/notification': 'Notifications',
  '/logout': 'Logout',
};

function Dashboard(props) {
  const { window: windowProp } = props;
  const details = localStorage.getItem('userdetails')
  const user = JSON.parse(details)
  const location = useLocation();
  console.log(location)
  const [open, setOpen] = useState(false)
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [notifications, setNotifications] = useState([]);
  const [showNotiDropdown, setShowNotiDropdown] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [markingNotificationId, setMarkingNotificationId] = useState(null);
  const [initialAuthReady, setInitialAuthReady] = useState(false);

  const fetchUnreadCount = () => {
    getServices.getAdminNotificationUnreadCount().then((res) => {
      if (res.data?.status === "2000") {
        setUnreadCount(res.data.data?.count || 0);
      }
    }).catch((err) => {
      console.error("Error fetching unread notification count:", err);
    });
  };

  const fetchInboxNotifications = () => {
    getServices.getAdminNotificationInbox().then((res) => {
      if (res.data?.status === "2000") {
        setNotifications(res.data.data || []);
      }
    }).catch((err) => {
      console.error("Error fetching inbox notifications:", err);
    });
  };

  const handleNotificationToggle = () => {
    const nextOpen = !showNotiDropdown;
    setShowNotiDropdown(nextOpen);

    if (nextOpen) {
      fetchInboxNotifications();
      fetchUnreadCount();
    }
  };

  const getNotificationReadId = (notification) => {
    return notification?.notificationId || notification?.adminNotificationId || notification?.id;
  };

  const markNotificationAsRead = (notification) => {
    const notificationReadId = getNotificationReadId(notification);

    if (!notificationReadId || notification.readStatus || markingNotificationId) return;

    setMarkingNotificationId(notificationReadId);
    putServices.markNotificationAsRead(notificationReadId).then((res) => {
      if (String(res.data?.status) === "2000") {
        setNotifications((items) =>
          items.map((item) =>
            item.id === notification.id ? { ...item, readStatus: true } : item
          )
        );
        fetchUnreadCount();
      } else {
        toast(res.data?.description || 'Unable to mark notification as read');
      }
    }).catch((err) => {
      console.error("Error marking notification as read:", err);
      toast(err.response?.data?.description || 'Unable to mark notification as read');
    }).finally(() => {
      setMarkingNotificationId(null);
    });
  };

  const formatNotificationDate = (date) => {
    if (!date) return 'No date';
    return new Date(date).toLocaleString();
  };

  const currentYear = new Date().getFullYear();

  const getHeaderText = () => {
    const pathname = location.pathname;
    
    let pageName = routeToPageName[pathname];
    
    if (!pageName) {
      const baseRoute = pathname.split('/').slice(0, 2).join('/');
      pageName = routeToPageName[baseRoute];
    }
    
    pageName = pageName || 'Unknown Page';
    
    return pathname === '/dashboard' || pathname === '/'
      ? `Welcome ${user.lastName}`
      : pageName;
  };

  useEffect(() => {
    let lastActivityTime = Date.now();
    const IDLE_TIMEOUT = 15 * 60 * 1000; // 15 minutes of inactivity
    let refreshInterval;
    let checkInterval;

    const updateActivity = () => {
      lastActivityTime = Date.now();
    };

    window.addEventListener('mousemove', updateActivity);
    window.addEventListener('keypress', updateActivity);
    window.addEventListener('click', updateActivity);
    window.addEventListener('scroll', updateActivity);

    const handleSessionEnd = (message) => {
      if (refreshInterval) clearInterval(refreshInterval);
      if (checkInterval) clearInterval(checkInterval);
      
      toast(message, {
        onClose: () => {
          window.location.replace('/logout');
        },
        autoClose: 3000
      });
    };

    const doRefresh = (options = {}) => {
  const { markReady = false } = options;
  const timeSinceActivity = Date.now() - lastActivityTime;

  if (timeSinceActivity < IDLE_TIMEOUT) {
    refreshAdminToken().then(
      (response) => {
        if (!response) {
          if (markReady) setInitialAuthReady(true);
          return;
        }

        if (response.data.status === '2000') {
          cookie.save("token", response.data.data.Token, {
            path: "/",
            expires: new Date(Date.now() + 17 * 60 * 1000),
          });
          if (markReady) setInitialAuthReady(true);
          fetchUnreadCount(); // ✅ fetch AFTER token is fresh
        } else {
          handleSessionEnd('Session Expired');
        }
      },
      (error) => {
        handleSessionEnd('Session Expired');
      }
    );
  } else {
    handleSessionEnd('Session expired due to inactivity');
  }
};

    checkInterval = setInterval(() => {
      const token = cookie.load("token");
      const timeSinceActivity = Date.now() - lastActivityTime;

      if (timeSinceActivity > IDLE_TIMEOUT) {
        handleSessionEnd('Session expired due to inactivity');
        return;
      }

      if (!token) {
        handleSessionEnd('Session Invalid');
        return;
      }
    }, 10000);

    doRefresh({ markReady: true });

    refreshInterval = setInterval(doRefresh, 15 * 60 * 1000);

    return () => {
      if (checkInterval) clearInterval(checkInterval);
      if (refreshInterval) clearInterval(refreshInterval);
      window.removeEventListener('mousemove', updateActivity);
      window.removeEventListener('keypress', updateActivity);
      window.removeEventListener('click', updateActivity);
      window.removeEventListener('scroll', updateActivity);
    };
  }, []);

  useEffect(() => {
    let unsubscribe;
    let isMounted = true;

    listenToForegroundMessages(({ title, body }) => {
      if (!isMounted) return;

      if (title || body) {
        toast(
          <div>
            {title ? <p className="font-bold text-back-color2">{title}</p> : null}
            {body ? <p className="mt-1 text-sm text-[#44474E]">{body}</p> : null}
          </div>,
          { autoClose: 6000 }
        );
      }

      fetchUnreadCount();
      fetchInboxNotifications();
    }).then((listenerUnsubscribe) => {
      unsubscribe = listenerUnsubscribe;
    }).catch((error) => {
      console.error("Unable to listen for foreground notifications:", error);
    });

    return () => {
      isMounted = false;
      if (unsubscribe) unsubscribe();
    };
  }, []);


  const drawer = (
    <div>
      <div className=' pt-2 border-b border-b-gray-300 mb-2 pb-4 bg-[#F8FAFC] px-4 sm:px-12 py-4 sm:py-10'>
        <img src={Logo} alt='logo' className='  mx-auto' />
      </div>

      <List>
        {sidebar.map((text, index) => (
          <NavLink
            key={index}
            className={({ isActive }) => {
              return (' block p-3 mb-3 pl-6 ' + (
                !isActive ? ' block ' : ' bg-[#F5F1FE] border-l-4  border-l-primary-color text-back-color2 block'
              ))
            }}
            to={text.link}>
            {text.icon}
            <span className=' pl-3'>{text.name}</span>
          </NavLink>
        ))}
      </List>
    </div>
  );

  const container = windowProp !== undefined ? () => windowProp().document.body : undefined;
  
  return (
    <div>
      <ToastContainer />
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            width: { xs: '100%', sm: `calc(100% - ${drawerWidth}px)` },
            ml: { xs: 0, sm: `${drawerWidth}px` },
            backgroundColor: '#F8FAFC',
          }}
        >
          <div className=' flex justify-between'>
            <div className=' flex justify-between'>
              <Toolbar className="flex justify-between items-center px-4 sm:px-6">
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { xs: 'block', sm: 'none' } }}
                >
                  <MenuIcon />
                </IconButton>
              </Toolbar>
              
              <div className='flex flex-col justify-center'>
                <p className='text-black md:text-[24px] capitalize font-[400]'>{getHeaderText()}</p>
              </div>
            </div>

            <div className=' md:flex hidden justify-center gap-2'>
              <div className='relative mt-3'>
                <button
                  type='button'
                  className='relative flex h-10 w-10 items-center justify-center rounded-full border-none bg-white text-back-color2 shadow-sm'
                  onClick={handleNotificationToggle}
                >
                  <NotificationsNoneOutlinedIcon fontSize='medium' />
                  {unreadCount > 0 && (
                    <span className='absolute -right-1 -top-1 flex min-h-[18px] min-w-[18px] items-center justify-center rounded-full bg-primary-color px-1 text-[10px] font-bold text-white'>
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </button>

                {showNotiDropdown && (
                  <div className='absolute right-0 top-10 z-50 w-[360px] rounded-lg bg-white shadow-lg'>
                    <div className='border-b border-gray-100 px-4 py-3'>
                      <p className='text-[16px] font-bold text-back-color2'>Notifications</p>
                    </div>

                    <div className='max-h-[360px] overflow-y-auto'>
                      {notifications.length === 0 ? (
                        <p className='px-4 py-6 text-center text-[14px] text-[#44474E]'>No notifications found</p>
                      ) : (
                        notifications.map((notification) => (
                          <button
                            key={notification.id}
                            type='button'
                            disabled={markingNotificationId === getNotificationReadId(notification)}
                            onClick={() => markNotificationAsRead(notification)}
                            className={`block w-full border-b border-gray-100 px-4 py-3 text-left disabled:cursor-wait disabled:opacity-80 ${
                              notification.readStatus ? 'bg-white' : 'bg-[#F5F1FE]'
                            }`}
                          >
                            <div className='mb-1 flex items-start justify-between gap-3'>
                              <p className='text-[14px] font-bold text-back-color2'>
                                {notification.header}
                              </p>
                              {!notification.readStatus && (
                                <span className='mt-1 h-2 w-2 shrink-0 rounded-full bg-primary-color' />
                              )}
                            </div>
                            <p className='mb-2 text-[13px] text-[#44474E]'>{notification.content}</p>
                            <p className='text-[12px] text-primary-color'>
                              {formatNotificationDate(notification.createdDate)}
                            </p>
                          </button>
                        ))
                      )}
                    </div>

                    {/* <Link
                      to='/notification'
                      onClick={() => setShowNotiDropdown(false)}
                      className='block border-t border-gray-100 px-4 py-3 text-center text-[14px] font-bold text-primary-color'
                    >
                      View all notifications
                    </Link> */}
                  </div>
                )}
              </div>

              <div className=' mt-3 flex gap-2 mr-3 relative cursor-pointer' onClick={() => setOpen(!open)}>
                <div>
                  <p className=' px-3 py-2 rounded-[44px] bg-back-color2'> {Array.from(user.lastName)[0]}</p>
                </div>

                <div>
                  <p className=' text-black inline-block text-[16px] mr-4'> {user.firstName} {user.lastName} </p>
                  <p className=' text-back-color2 text-[12px]'>{user.userRole}</p>
                </div>
                <div className=' pt-2'>
                  {open ? <ArrowDropUpIcon className=' text-back-color2' /> : <ArrowDropDownIcon className=' text-back-color2' />}
                  {open && <div className=' mt-3 absolute top-12 right-0 rounded-lg p-6 pr-16 shadow-md text-back-color2 bg-white'>
                    <p className=' mb-4'> <Link to='/settings'><SettingsIcon /> <span>Settings</span></Link> </p>
                    <p className=' mb-4'><Link to='/logout'><LogoutIcon /> <span>Logout</span></Link></p>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </AppBar>        
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, 
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: 'white' },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: 'white' },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>        
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
        >
          <Toolbar />
          <div className=' w-full' >
            {initialAuthReady && <Routess />}
          </div>
          <div className=' bg-white mt-5  left-0  fixed bottom-0 p-3 w-full '>
            <h6 className=' text-[#14013A] font-[500] text-[14px] text-center'>©{currentYear} Halal wealth</h6>
          </div>
        </Box>
        
      </Box>
    </div>
  )
}
Dashboard.propTypes = {
  window: PropTypes.func,
};

export default Dashboard;
